<template>
    <div class="user-add-address">
        <van-address-edit :area-list="areaList" :address-info='init_area' show-postal show-delete show-set-default show-search-result :area-columns-placeholder="['请选择', '请选择', '请选择']" @save="onSave" @delete="onDelete" @change-detail="onChangeDetail" :show-postal='false'/>
    </div>
</template>
<script>
    import areaList from './area.js'
    export default {
        data() {
            return {
                init_area: {},
                areaList,
            };
        },
        mounted(){
            let self = this
            let address_id = self.$route.query.address_id
            console.log(address_id)
            if(address_id){
                self.$http.post('/v1/get_address',{address_id}).then(function(re){
                    console.log(re.body.address)
                    self.init_area = re.body.address
                })
            }
        },
        computed:{
            is_edit(){
                return this.$route.query.address_id
            }
        },
        methods: {
            onSave(res) {
                let self = this
                if(self.is_edit){
                     self.$http.post('/v1/update_address', {
                    address: res,
                         address_id:self.is_edit
                }).then(function(re){
                    console.log(re)
                    self.$router.go(-1)
                })
                }else{
                     self.$http.post('/v1/set_address', {
                    address: res
                }).then(function(re){
                    console.log(re)
                    self.$router.go(-1)
                })
                }
                console.log('res', res)
               
            },
            onDelete() {

            },
            onChangeDetail(val) {
                //      if (val) {
                //        this.searchResult = [
                //          {
                //            name: '黄龙万科中心',
                //            address: '杭州市西湖区',
                //          },
                //        ];
                //      } else {
                //        this.searchResult = [];
                //      }
            },
        },
    };

</script>
